import { createContext, useContext } from "react";

/** React context follows portals, so nested surfaces stay above their owning overlay. */
export const OverlayLayerContext = createContext<string | null>(null);

export function useOverlayLayer(kind: "modal" | "dropdown") {
  const parent = useContext(OverlayLayerContext);
  const base = `var(--z-z-${kind})`;
  // Leave a layer between surfaces for a nested modal's backdrop.
  return parent === null ? base : `max(${base}, calc(${parent} + 2))`;
}
